import React from "react";
import { FIELDS } from "../../../conts/historyConsts";
import DatePickerField from "../../atoms/datePickerField/DatePickerField";
import "./AnalysesFilters.css";

/* Reusable filter form (analyses list + stats picker).
   Controlled: the parent owns `value` (the draft) and the actions. */
const AnalysesFilters = ({
  value,
  onChange,
  onSubmit,
  onReset,
  submitLabel = "Appliquer",
  resetLabel = "Réinitialiser",
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(value);
  };

  const set = (key, v) => onChange({ ...value, [key]: v });

  return (
    <form className="afilters" onSubmit={handleSubmit}>
      {FIELDS.map((f) => (
        <label
          key={f.k}
          className={`afilters__field ${f.wide ? "afilters__field--wide" : ""}`}
        >
          <span>{f.label}</span>

          {f.type === "date" ? (
            <DatePickerField
              value={value[f.k]}
              onChange={(v) => set(f.k, v)}
              valueFormat="yyyy-MM-dd"
              minDate={f.min}
              maxDate={f.max}
              clearable
              className="afilters__input"
            />
          ) : (
            <input
              className="afilters__input"
              type={f.type}
              min={f.min}
              step={f.step}
              maxLength={f.maxLength}
              placeholder={f.placeholder}
              value={value[f.k]}
              onChange={(e) => set(f.k, e.target.value)}
            />
          )}
        </label>
      ))}

      <div className="afilters__actions">
        <button type="button" className="afilters__btn" onClick={onReset}>
          {resetLabel}
        </button>
        <button type="submit" className="afilters__btn afilters__btn--solid">
          {submitLabel}
        </button>
      </div>
    </form>
  );
};

export default AnalysesFilters;